const $ = require('jquery');
import _ from "underscore";
import run from '../../utilities/run';
import render from "../../utilities/render";
import { SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT } from "../../constants";
import { handleDisplayFor, setElementsFromScope } from "../../utilities/selectorHelpers";
import { createPreventDefault } from '../../utilities/general';
import { instantiateSelect2 } from "../../utilities/select2able";
import { setSwitchery, instantiateSwitchery } from "../../utilities/instantiateSwitchery";
import Scheduler from '../../components/scheduler';
import { getMap } from '../appointmentForm/elementsBindMap';
import QuickBtnGroup from '../../components/QuickBtnGroup/QuickBtnGroup';
import EditChecker from '../../components/EditChecker/EditChecker';
import { isNull, isNullOrUndefined } from 'util';
const inventory = require('./html/inventory.html');
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
const optionTemplateHtml = require('../../sharedHtml/linkGroup/optionTemplate.html');

run("#appointment-form", (el) => {
	const portletNamespace = el.data("portlet-namespace");
	const appointmentDuration = el.data("appointment-duration-url");
	const asnDetailsUrl = el.data("asn-details-url");
	const appointmentSlotUrl = el.data("appointment-slots-url");
	const asnDetailScreenUrl = el.data("asn-details-screen-url");
	const facilityUser = el.data("is-facility-user");
	const brokerUser = el.data("is-broker-user");
	const carrierUser = el.data("is-carrier-user");
	const asnPortlet = el.data("asn-portlet");
	const getCarriersDetailsUrl= el.data("carriers-details-url");
	const isEdit = el.data("edit-flag");
	const editAppointmentData = el.data("edit-appointment-data");
	const cancelBtnUrl = el.data("cancel-url");
	const merchantName = el.data("merchant-name");
	const elementsPageMap = getMap();
	const submitModalFlow = new SubmitModalFlow();
	
	submitModalFlow.init();

	let retailersList = [],
		existingList = [],
		elsPage = {},
		appointmentScheduler,
		duration,
		appDate,
		appTime,
		dock,
		doorNum,
		appStatus,
		aptId,
		facilityName,
		appDuration,
		slotSelected,
		btnClick,
		loadTypeBtnToggle,
		inventorySkuBtnToggle;

	let validator;
	slotSelected= false;
  	let validationOpts = {
    	debug: true,
    	errorPlacement: function(error, element) {
      		let appendClosest = $(element).data('error-placement-append-closest');
      		if (appendClosest) {
        		$(element).closest(appendClosest).append(error);
      		} else {
        		error.insertAfter(element);
      		}
    	}
  	}

	init();

	const appointmentTypesList = elsPage.appointmentTypes.data('options');
	const heightsList = elsPage.heights.data('options');
	const facilitiesList = elsPage.facilities.data('options');
	const trailerTypesList = elsPage.trailerTypes.data('options');
	const retailers = elsPage.retailerList.data('options');
	const carriersList = elsPage.carrierOrganizations.data('options');

	loadDropDowns();

	function init() {
		setElements();
		bindElements();
		generateBtnToggle();
		setupEditChecker();	
		setValidator();
	}

	function setValidator() {
    	validator = el.validate(validationOpts);
    	validator.settings.ignore=":disabled, :hidden";
  	}

	if(isEdit) {
		populateValuesForEdit();
		elsPage.submitBtn.removeAttr('disabled');
		elsPage.editMessage.addClass('hidden');
	}

	function setElements() {
		setElementsFromScope(elsPage, elementsPageMap, el);
		initDatePickerComp();
	}

	function initDatePickerComp() {
		const today = new Date();
		var nextDay = new Date();
		nextDay.setDate(today.getDate() + 1);
		const singleDatepickerEl = elsPage.appointmentDate;
		singleDatepickerEl.datepicker({
			startDate: nextDay,
			keyboardNavigation: false,
			autoclose: true
		});
	}

	function setupEditChecker() {
    	EditChecker.bindNavigation();
   	 	EditChecker.bindChangeListener("#appointment-form");
   	 	EditChecker.bindChangeListener("span.select2");
    	EditChecker.bindCancelButton(".cancel-url");
  	}

	function bindElements() {
		if(!isEdit){
			elsPage.submitBtn.attr('disabled', 'disabled');
		}
		elsPage.appointmentTypes.on("change.select2", appointmentTypesHandler);
		elsPage.trailerTypes.on("change", trailerTypesHandler);
		elsPage.facilities.on("change", facilitySection);
		elsPage.pallets.on("click", palletHandler);
		elsPage.floorLoaded.on("click", floorLoadedHandler);
		elsPage.heights.on("change", availabilitySection);
		elsPage.numberOfPallets.on("change", availabilitySection);

		elsPage.singleSku.on("click", function (e) {
			e.preventDefault();
			elsPage.inventorySection.val(true);
		});

		elsPage.mixedSkus.on("click", function (e) {
			e.preventDefault();
			elsPage.inventorySection.val(false);
		});

		elsPage.checkAppointmentBtn.on("click", loadAppointmentSlot);
		elsPage.addAsnBtn.on("click", asnDetailSection);
		elsPage.submitBtn.on("click", submitAppointmentHandler);
		elsPage.retailerList.on("change.select2", ()=>{
			if(facilityUser){
				carrierSelect();
			}
		});

	}

	function carrierSelect(){
		let retailerSelected = elsPage.retailerList.val();
		let retailersObj = [];
		(retailerSelected).map((retailer)=>{
			retailersObj.push({retailerIds: retailer});
		});
		
		$.ajax({
			data: { 
			[`${portletNamespace}retailersObj`]: JSON.stringify(retailersObj)
			},
			url: getCarriersDetailsUrl,
			dataType:"JSON",
			type: 'POST',
			success: function(data){
				elsPage.carrierOrganizations.empty().trigger('change')
				const CarrierOptions = (data).map((carr)=>{
					return render(optionTemplateHtml, {
						targetKey: carr.carScac,
						text: carr.carScac +" - " +carr.carName
					});
				});
				elsPage.carrierOrganizations.append(CarrierOptions.join(''));  
			  
			}  
		 });
	}	

	function generateBtnToggle(){
		loadTypeBtnToggle = new QuickBtnGroup(elsPage.loadTypeBtnToggleEl,{
			distributeWidth: true
		});
		loadTypeBtnToggle.init();

		inventorySkuBtnToggle = new QuickBtnGroup(elsPage.inventorySkuBtnToggleEl,{
			distributeWidth: true
		});
		inventorySkuBtnToggle.init();
	}

	function floorLoadedHandler(){
		defaultValues();
		elsPage.loadType.val("Floor Loaded");
		elsPage.floorLoaded.addClass("active");
		elsPage.pallets.removeClass("active");
		elsPage.cases.val('');
		elsPage.casesSection.removeClass("hidden");
		elsPage.palletsSection.addClass("hidden");
		btnClick = true;
		elsPage.trailerNumber.removeClass("hidden");
		elsPage.skuSection.removeClass("hidden");
	}
	function trailerTypesHandler(){
		defaultValues();
		commonForTrailerType();
		if (elsPage.trailerTypes.val() === "LTL") {
			elsPage.loadType.addClass("hidden");
			elsPage.trailerNumber.removeClass("hidden");
		}
		else {
			elsPage.loadType.removeClass("hidden");
			elsPage.floorLoaded.removeClass("active");
			elsPage.pallets.removeClass("active");
			elsPage.singleSku.removeClass("active");
			elsPage.mixedSkus.removeClass("active");
			elsPage.trailerNumber.addClass("hidden");
			}
	}

	function appointmentTypesHandler(){
		commonSections();

		if (elsPage.appointmentTypes.val() === "Live Unload") {
			elsPage.liveUnload.removeClass("hidden");
			elsPage.dropUnload.addClass("hidden");
			elsPage.pickupEmpty.addClass("hidden");
			elsPage.shippingSection.removeClass("hidden");
			elsPage.trailerNumber.addClass("hidden");
			elsPage.inventorySection.removeClass("hidden");
			if (carrierUser){
				elsPage.merchant.removeClass("hidden");
				loadMerchantName();
			}
			else{
				elsPage.merchant.addClass("hidden");
				}			
			
		} else if (elsPage.appointmentTypes.val() === "Drop Unload") {
			elsPage.shippingSection.addClass("hidden");
			elsPage.liveUnload.addClass("hidden");
			elsPage.pickupEmpty.addClass("hidden");
			elsPage.dropUnload.removeClass("hidden");
			elsPage.trailerNumber.removeClass("hidden");
			if (carrierUser) {
				elsPage.merchant.removeClass("hidden");
				loadMerchantName();
			}
			else {
				elsPage.merchant.addClass("hidden");
			}	
			elsPage.inventorySection.removeClass("hidden");

		} else if (elsPage.appointmentTypes.val() === "Pickup Empty") {
			appointmentTypeSections();
			elsPage.trailerRequired.removeClass("hidden");
			elsPage.trailer.addClass("required");
			elsPage.pickupEmpty.removeClass("hidden");
			if(facilityUser){
				elsPage.merchant.removeClass("hidden");
			}
			if (brokerUser || carrierUser){
				elsPage.merchant.removeClass("hidden");
				loadMerchantName();
			}	
		} else {
			appointmentTypeSections();
			elsPage.pickupEmpty.addClass("hidden");
			elsPage.merchant.removeClass("hidden");
			if (brokerUser || carrierUser){
				loadMerchantName();
			}
		}
	}

	function loadMerchantName(){
		elsPage.retailerList.val(merchantName);
		elsPage.retailerList.trigger('change.select2');
		elsPage.retailerList.attr('disabled','disabled');
		let select2TargetEl = elsPage.retailerList.data('target-closest');
		let parentEl = elsPage.retailerList.closest(select2TargetEl);
		parentEl.find('.select2-container').css('pointer-events','none');
	}

	function palletHandler(){
		elsPage.loadType.val("Pallets");
		elsPage.pallets.addClass("active");
		defaultValues();
      	elsPage.floorLoaded.removeClass("active");
      	elsPage.numberOfPallets.val('');
		elsPage.palletsSection.removeClass("hidden");
		elsPage.casesSection.addClass("hidden");
		elsPage.trailerNumber.removeClass("hidden");
		elsPage.skuSection.removeClass("hidden");
		btnClick = true;
	}

	function loadAppointmentSlot() {
		elsPage.submitBtn.attr('disabled', 'disabled');
		elsPage.slotError.hide();
		if(!btnClick && elsPage.appointmentTypes.val() === "Live Unload" 
			&& elsPage.trailerTypes.val() && elsPage.trailerTypes.val() != "LTL"){
			elsPage.loadTypeError.removeClass('hidden');
			return;
		}
		const isFormValid = el.valid();
		if(isFormValid){
			const datePicked = elsPage.appointmentDate.val();
			if (datePicked) {
				let appointmentResponse = null;
				let appointmentTypeObj = getAppointentTime();
				$.ajax({
					url: appointmentDuration,
					dataType: "JSON",
					type: 'POST',
					data: {
						[`${portletNamespace}appointmentType`]: JSON.stringify(appointmentTypeObj)
					}, success: function (data) {
						appointmentResponse = data.appointmentType;
						duration = appointmentResponse.aptAppointmentDuration;
						let facId = appointmentResponse.aptFacId;
						aptId = appointmentResponse.aptId;
						elsPage.appDurationTime.text(duration);
						loadAppointmentSlots(duration, facId)
					}
				});	
			}
		}
	}

	function loadAppointmentSlots(appDuration, facId){
		const datePicked = elsPage.appointmentDate.val();
		let slotRequest = {};
		slotRequest.appointmentDate = datePicked;
		slotRequest.appointmentDuration = appDuration;
		slotRequest.appointmentFacId = facId;
		submitModalFlow.showLoadingModal();
		$.ajax({
			url: appointmentSlotUrl,
			dataType: "JSON",
			type: 'POST',
			data: {
				[`${portletNamespace}slotRequest`]: JSON.stringify(slotRequest)
			},
			success: function (data) {
				submitModalFlow.hideAllModals();
				if(data.success){
					elsPage.appointmentSchedulerContainer.removeClass('hidden');
					showSchedular(data.slots);
				}
			},
			error: function (data) {
				submitModalFlow.hideAllModals();
				submitModalFlow.showFailureModal();
			}
		});
	}

	function showSchedular(slotResponse) {
		const datePicked = elsPage.appointmentDate.val();
		const today = new Date();
		const pickedDate = new Date(datePicked);
		var nextDay = new Date();
		nextDay.setDate(today.getDate() + 1);
		if (pickedDate.getDate() == nextDay.getDate() || pickedDate.getDate() == today.getDate()) {
			elsPage.nxtDayMsg.removeClass('hidden');
		} else {
			elsPage.nxtDayMsg.addClass('hidden');
		}
		elsPage.availableMsg.removeClass('hidden');
		elsPage.oneHrMsg.removeClass('hidden');
		appointmentScheduler = new Scheduler({
			target: '.appointment-scheduler',
			data: slotResponse,
			activeIndex: 1
		});
		appointmentScheduler.init();
		elsPage.disclaimerMsg.removeClass('hidden');

		$('.time-block-div input[type=radio]').click(submitBtnEnable);
	}

	function submitBtnEnable() {
		elsPage.submitBtn.removeAttr('disabled');
		elsPage.slotError.hide();
		slotSelected= true;
		elsPage.editMessage.addClass('hidden');
	}

	function asnDetailSection(e) {
		elsPage.asnRequiredError.addClass('hidden');
		let facId = elsPage.facilities.val();
		let selectedShipmentId = elsPage.asn.val();
		elsPage.asnError.hide();
		if (null == selectedShipmentId || selectedShipmentId == "") {
			elsPage.asn.val('');
			elsPage.asnInvalidError.show();
			return;
		} else if (existingList.indexOf(selectedShipmentId) > -1) {
			elsPage.asn.val('');
			elsPage.asnDuplicateError.show();
			return;
		}

		let existingListStr = "";
		$.each(existingList, function (index, item) {
			if (existingListStr.length > 0) {
				existingListStr = existingListStr + "," + item;
			} else {
				existingListStr = existingListStr + item;
			}
		});
		e.preventDefault();
		elsPage.asnDetails.removeClass("hidden");
		$.ajax({
			data: {
				[`${portletNamespace}shipmentId`]: selectedShipmentId,
				[`${portletNamespace}existingList`]: existingListStr,
				[`${portletNamespace}facId`]: facId
			},
			url: asnDetailsUrl,
			async:false,
			dataType: "JSON",
			type: 'POST',
			success: function (data) {
				elsPage.asn.val('');
				if (data.status == 'success') {
					let asnData = data.asn[0];
					let facilityData = data.facility;
					let retailerData = data.retailer[0];
					let palletCount = data.palletCount;
					let cmrAddressData = data.cmrAddress;
					existingList.push(asnData.asnShipmentId);

					let index = retailersList.indexOf(asnData.asnRtlId);
					if (index < 0) {
						retailersList.push(asnData.asnRtlId);
					}

					buildInvetorySection(asnData, palletCount, retailerData, facilityData, cmrAddressData)
					
				} else {
					elsPage.asnGenericErrorLabel.text(data.errorMessage);
					elsPage.asnGenericError.show();
				}
			},
			error: function (data) {
				elsPage.asn.val('');
				submitModalFlow.hideAllModals();
                submitModalFlow.showFailureModal();
			}

		});
	}

	function removeAsn(e) {
		e.preventDefault();
		let asnData = e.data;
		let index = existingList.indexOf(asnData.asnShipmentId);
		if (index > -1) {
			existingList.splice(index, 1);
			$('#asn-section-' + asnData.asnShipmentId).remove();
		}

		index = retailersList.indexOf(asnData.asnRtlId);
		if (index > -1) {
			retailersList.splice(index, 1);
		}
		
	}

	function viewAsnDetails(e) {
		e.preventDefault();
		let asnData = e.data;
		let asnDetailsFinalUrl = asnDetailScreenUrl + '&' + asnPortlet + 'asnId=' + asnData.asnId;
		window.open(asnDetailsFinalUrl);
	}

	function loadDropDowns() {

		const appointmentTypeOptions = (appointmentTypesList).map((item)=>{
			return render(optionTemplateHtml, {
				targetKey: item.cdmValue,
				text: item.cdmMeaning
			});
		});
		elsPage.appointmentTypes.append(appointmentTypeOptions.join(''));

		const palletHeightOptions = (heightsList).map((item)=>{
			return render(optionTemplateHtml, {
				targetKey: item.cdmValue,
				text: item.cdmMeaning
			});
		});
		elsPage.heights.append(palletHeightOptions.join(''));

		const trailerTypeOptions = (trailerTypesList).map((item)=>{
			return render(optionTemplateHtml, {
				targetKey: item.cdmValue,
				text: item.cdmMeaning
			});
		});
		elsPage.trailerTypes.append(trailerTypeOptions.join(''));

		const retailerOptions = (retailers).map((item)=>{
			return render(optionTemplateHtml, {
				targetKey: item.rtlId,
				text: item.rtlName
			});
		});
		elsPage.retailerList.append(retailerOptions.join(''));

		const facilityOptions = (facilitiesList).map((item)=>{
			return render(optionTemplateHtml, {
				targetKey: item.facId,
				text: item.facName
			});
		});
		elsPage.facilities.append(facilityOptions.join(''));
		if(!facilityUser){
			const CarrierOptions = _(carriersList).map((carr)=>{
				return render(optionTemplateHtml, {
					targetKey: carr.carScac,
					text: carr.carScac +" - " +carr.carName
				});
			});
			
			elsPage.carrierOrganizations.append(CarrierOptions.join(''));
			if (carrierUser) {
				elsPage.carrierOrganizations.prop('selectedIndex', '1').trigger('change.select2');
				elsPage.carrierOrganizations.attr('disabled', 'disabled');
			}
		}
		if(facilityUser){
			elsPage.facilities.prop('selectedIndex', '1').trigger('change.select2');
			elsPage.facilities.attr('disabled', 'disabled');
		}
	}

	function commonSections() {
		retailersList = [];
		elsPage.arrivalTime.removeClass("hidden");
		elsPage.additionalInfo.removeClass("hidden");
		elsPage.destinationSection.removeClass("hidden");
		elsPage.loadType.addClass("hidden");
		elsPage.retailerList.val([]).change();
		elsPage.trailerTypes.val('').trigger('change.select2');
		elsPage.notes.val('');		
		elsPage.trailerRequired.addClass("hidden");
		elsPage.trailer.removeClass("required");
		defaultValues();
		commonForTrailerType();
	}

	function defaultValues() {
		availabilitySection();
		btnClick = false;
		elsPage.loadTypeError.addClass('hidden');
		elsPage.trailer.val('');
		elsPage.numberOfPallets.val('');
		elsPage.cases.val('');
		elsPage.heights.val('').trigger('change.select2');
		elsPage.mixedSkus.removeClass("active");
		elsPage.singleSku.removeClass("active");
		elsPage.inventorySection.val('');
	}

	function availabilitySection() {
		if(isEdit){
			elsPage.asnAlert.removeClass('hidden');
			elsPage.shippingAlert.removeClass('hidden');
			elsPage.editMessage.removeClass('hidden');
		}
		elsPage.submitBtn.attr('disabled', 'disabled');
		elsPage.oneHrMsg.addClass('hidden');
		elsPage.nxtDayMsg.addClass('hidden');
		elsPage.slotError.hide();
		elsPage.appointmentSchedulerContainer.addClass('hidden');
		elsPage.availableMsg.addClass('hidden');
		elsPage.disclaimerMsg.addClass('hidden');
	}

	function facilitySection() {
		availabilitySection();
		existingList = [];
		elsPage.asnDetails.empty();		
	}

	function appointmentTypeSections() {
		elsPage.trailerNumber.removeClass("hidden");
		elsPage.liveUnload.addClass("hidden");
		elsPage.dropUnload.addClass("hidden");
		elsPage.shippingSection.addClass("hidden");
		elsPage.inventorySection.addClass("hidden");
	}

	function commonForTrailerType() {
		elsPage.palletsSection.addClass("hidden");
		elsPage.casesSection.addClass("hidden");
		elsPage.skuSection.addClass("hidden");
	}

	function getAppointentTime() {
		let appointmentTypeObj = {};
		appointmentTypeObj.appointmentType = elsPage.appointmentTypes.val();
		appointmentTypeObj.facility = elsPage.facilities.val();
		if (elsPage.appointmentTypes.val() === "Live Unload") {
			if (elsPage.trailerTypes.val() === "LTL") {
				appointmentTypeObj.trailerType = elsPage.trailerTypes.val();
			}
			else {
				appointmentTypeObj.loadType = elsPage.loadType.val();
				appointmentTypeObj.trailerType = elsPage.trailerTypes.val();
				if (elsPage.loadType.val() != "Floor Loaded") {
					appointmentTypeObj.numberOfPallets = elsPage.numberOfPallets.val();
					appointmentTypeObj.palletHeight = elsPage.heights.val();
				}
				else {
					appointmentTypeObj.numberofCases = elsPage.cases.val();
				}
			}
		}
		return appointmentTypeObj;
	}

	function submitAppointmentHandler() {
		const isFormValid = el.valid();
		if((elsPage.appointmentTypes.val() === "Live Unload" 
				|| elsPage.appointmentTypes.val() === "Drop Unload") 
				&& $('.asn-section').length == 0){
			elsPage.asnRequiredError.removeClass('hidden');
			return;
		}
		if(isFormValid){
	    	const viewDetailUrl = elsPage.submitBtn.data("view-detail");
	    	const saveAppointmentUrl = elsPage.submitBtn.data("save-appointment-url");
	    	const submitModalFlow = new SubmitModalFlow({
	        	confirmModalTitle: "Submitting Appointment",
	        	confirmModalBody: '<div class="q-pad-all-xl">Once submitted this scheduled appointment time will be sent to the facility destination and held for this organization. The appointment may be changed or canceled up till 24 hrs. before the scheduled arrival.</div>',
	        	confirmModalBtnText: "Submit",
	        	onConfirmClick: function () {
	            	let appointmentObj = prepareDataForSubmit();
	            	submitModalFlow.showLoadingModal();
	            	$.ajax({
	                	data: {
	                		[`${portletNamespace}appointment`]: JSON.stringify(appointmentObj)
	                	},
	                	url: saveAppointmentUrl,
	                	dataType: "JSON",
	                	type: 'POST',
	                	success: function (data) {
	                		EditChecker.setPageClean();
	                    	submitModalFlow.hideAllModals();
	                    	if (data.status == 'success') {
	                    		let appointment = data.appointment;
								let appId = appointment.appId;
	                        	submitModalFlow.showSuccessModal();
	                        	setTimeout(function () {
	                            	location.href = viewDetailUrl + '&appId=' + appId;
	                       		}, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	                    	} else {
	                        	elsPage.slotError.show();
	                        	elsPage.slotErrorMessage.text(data.errorMessage);
	                    	}
	                	},
	                	error: function () {
	                    	submitModalFlow.hideAllModals();
	                    	submitModalFlow.showFailureModal();
	                	}
	            	});
	        	}
	    	});

			submitModalFlow.init();
    		submitModalFlow.showConfirmModal();
		}
    	
    }

    function prepareDataForSubmit() {
    	let appointmentObj = {};
    	if(isEdit){
            appointmentObj.appId = editAppointmentData.appointment.appId;
            appointmentObj.status = appStatus;
        }
		let selectedmerchantIds = elsPage.retailerList.val();
		appointmentObj.appointmentType = elsPage.appointmentTypes.val();
		appointmentObj.carrierOrganizations = elsPage.carrierOrganizations.val();

		if(slotSelected){
			let slotsDetails= appointmentScheduler.getSelection();
			let availTime = slotsDetails[0].availTime;
			appointmentObj.appDateAndTime = slotsDetails[0].date + " " + availTime.startTime;
			appointmentObj.appDockId = availTime.dockId;
			appointmentObj.appDoorNumber = availTime.doorNumber;
		} 
		else{
			appointmentObj.appDateAndTime = appDate + " " + appTime;
			appointmentObj.appDockId = dock;
			appointmentObj.appDoorNumber = doorNum;
		}		
		appointmentObj.facility = elsPage.facilities.val();
		appointmentObj.duration = duration;
		appointmentObj.aptId = aptId;
		appointmentObj.appointmentNotes = elsPage.notes.val();
		appointmentObj.trailerNumber = elsPage.trailer.val();
		appointmentObj.facilityName = facilityName;
		appointmentObj.preferredDate = elsPage.appointmentDate.val();
		appointmentObj.appDuration = appDuration;

		if (elsPage.appointmentTypes.val() === "Live Unload" || elsPage.appointmentTypes.val() === "Drop Unload") {
			appointmentObj.objectIds = existingList;
			appointmentObj.objectType = "ASN";
			appointmentObj.retailers = retailersList;
		} else {
			appointmentObj.retailers = selectedmerchantIds;
		}

		if (elsPage.trailerTypes.val() === "LTL") {
			appointmentObj.trailerType = elsPage.trailerTypes.val();
		}
		else {
			appointmentObj.loadType = elsPage.loadType.val();
			appointmentObj.trailerType = elsPage.trailerTypes.val();
			appointmentObj.skuFlag = elsPage.inventorySection.val();
			if (elsPage.loadType.val() != "Floor Loaded") {
				appointmentObj.numberOfPallets = elsPage.numberOfPallets.val();
				appointmentObj.palletHeight = elsPage.heights.val();
			}
			else {
				appointmentObj.numberofCases = elsPage.cases.val();
			}
		}

		return appointmentObj;
    }

    function populateValuesForEdit() {
    	let appointment = editAppointmentData.appointment;
        if(!isNullOrUndefined(appointment.appointmentType)){
            elsPage.appointmentTypes.val(appointment.appointmentType).trigger('change');
        }
        if(!isNullOrUndefined(appointment.facility)){
            elsPage.facilities.val(appointment.facility).trigger('change');
        }
        if(!isNullOrUndefined(appointment.trailerType)){
        	elsPage.trailerTypes.val(appointment.trailerType).trigger('change');
        }

        if(!isNullOrUndefined(appointment.loadType)){
        	if(appointment.loadType === "Floor Loaded"){
				elsPage.floorLoaded.trigger('click');
        	} else{
				elsPage.pallets.trigger('click');
        	}
        }
        if(!isNullOrUndefined(appointment.trailerNumber)){
    		elsPage.trailer.val(appointment.trailerNumber);
		}
		if(!isNullOrUndefined(appointment.appointmentNotes)){			
    		elsPage.notes.val(appointment.appointmentNotes);
    	}
    	if(!isNullOrUndefined(appointment.numberOfPallets)){
    		elsPage.numberOfPallets.val(appointment.numberOfPallets);
    	}
    	if(!isNullOrUndefined(appointment.numberOfCases)){
    		elsPage.cases.val(appointment.numberOfCases);
    	}
    	if(!isNullOrUndefined(appointment.palletHeight)){
    		elsPage.heights.val(appointment.palletHeight);
    	}
    	if(!isNullOrUndefined(appointment.duration)){
    		appDuration = appointment.duration;
    	}
    	if(!isNullOrUndefined(appointment.status)){
    		appStatus = appointment.status;
    	}

    	if(!isNullOrUndefined(appointment.singleSkuFlag)){
    		if(appointment.singleSkuFlag){
				elsPage.singleSku.trigger('click');
    		}
    		else{
				elsPage.mixedSkus.trigger('click');
    		}
    	}
    	if(!isNullOrUndefined(editAppointmentData.appointmentDate)){
			appDate = editAppointmentData.appointmentDate;
    	}

    	if(!isNullOrUndefined(editAppointmentData.appointmentTime)){
			appTime = editAppointmentData.appointmentTime;
    	}
    	if(!isNullOrUndefined(appointment.dockId)){
			dock = appointment.dockId;
    	}
    	if(!isNullOrUndefined(appointment.doorNumber)){
			doorNum = appointment.doorNumber;
    	}
    	if(!isNullOrUndefined(appointment.appAptId)){
			aptId = appointment.appAptId;
    	}
    	
    	if(!isNullOrUndefined(appointment.appointmentRetailers) && facilityUser){
    		let merchantList = [];
    		$.each(appointment.appointmentRetailers, function(index, item) {
				merchantList.push(item.retailerId);
    		});
    		elsPage.retailerList.val(merchantList);
    	}

		if(appointment.asns && appointment.asns.length > 0){
			elsPage.asnDetails.removeClass("hidden");
			$.each(appointment.asns, function(index, asnData) {
				existingList.push(asnData.asnShipmentId);
				retailersList.push(asnData.asnRtlId);
				let retailerData = editAppointmentData.retailerData[0];
		    	buildInvetorySection(asnData, editAppointmentData.palletCount, retailerData, 
		    		editAppointmentData.facilityData, editAppointmentData.cmrAddressData);
			});			
		}
    }

    function buildInvetorySection(asnData, palletCount, retailerData, 
    		facilityData, cmrAddressData) {
    	let inventoryData = {};
		if(facilityUser || brokerUser || carrierUser){
			inventoryData.hidden = "hidden";
		} else{
			inventoryData.hidden = "";
		}
		inventoryData.asnData = asnData;
		inventoryData.palletCount = palletCount;
		inventoryData.retailerData = retailerData;
		inventoryData.facilityData = facilityData;
		inventoryData.cmrAddressData = cmrAddressData;
		let inventoryHtml = $(render(inventory, inventoryData));
		elsPage.asnDetails.append(inventoryHtml);
		$('#asn-section-' + asnData.asnShipmentId + ' #remove-asn-btn').bind('click',
			asnData, removeAsn);

		$('#asn-section-' + asnData.asnShipmentId + ' #view-asn-btn').bind('click',
			asnData, viewAsnDetails);
    }

});


// WEBPACK FOOTER //
// ./src/pages/appointmentForm/appointmentForm.js